import  { useState } from "react";
import { IconButton, Tooltip, Menu } from "@mui/material";
import { EmojiEmotions, EmojiEmotionsOutlined } from "@mui/icons-material";
import Picker from "emoji-picker-react";

const CustomEmojiPicker = ({ onSelect }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEmojiSelect = (emojiObject, event) => {
    if (onSelect && emojiObject?.emoji) {
      onSelect(emojiObject.emoji); // Correct way to pass emoji
    }
  };

  return (
    <>
      <Tooltip title="Emoji" placement="bottom" arrow>
        <IconButton
          onClick={handleOpen}
          sx={{ display: { xs: "none", sm: "flex" } }}
        >
          {anchorEl ? <EmojiEmotions /> : <EmojiEmotionsOutlined />}
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
        transformOrigin={{ horizontal: "right", vertical: "bottom" }}
        sx={{ display: { xs: "none", sm: "block" } }}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                bottom: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
      >
        <Picker
          style={{
            border: "none",
            outline: "none",
            width: "100%",
          }}
          onEmojiClick={handleEmojiSelect}
          previewConfig={{
            showPreview: false,
          }}
          theme={localStorage.getItem("freecomers_theme") || "light"}
          searchPlaceholder="Search Emoji"
          skinTonesDisabled={true}
          lazyLoadEmojis={true}
        />
      </Menu>
    </>
  );
};

export default CustomEmojiPicker;
